import { FC, useEffect, useState } from 'react';
import ActivityAttributionDialog from './ActivityAttributionDialog';
import MessageBus from '@restore/messagebus';
import { ActivityData } from './types';
import AttributionDurationService from '../../services/AttributionDurationService';

const MIN_ATTRIBUTION_DURATION = 30;

const ActivityAttribution: FC = () => {
  const [showDialg, setShowDialog] = useState(false);
  const [activityData, setActivityData] = useState<ActivityData>();
  const handleActivityAttribution = (payload?: unknown) => {
    const _activityData = payload as ActivityData;
    if (_activityData && _activityData.duration > MIN_ATTRIBUTION_DURATION) {
      setActivityData(_activityData);
      setShowDialog(true);
    }
    return null;
  };

  useEffect(() => {
    const messageBus = new MessageBus();
    const attributionDurationService = new AttributionDurationService();
    messageBus.subscribe('activityAttribution', handleActivityAttribution);
    return () => {
      messageBus.unsubscribe('activityAttribution');
      attributionDurationService.cleanup();
    };
  }, []);

  return (
    <>
      {showDialg && activityData && (
        <ActivityAttributionDialog
          activityData={activityData}
          closeDialog={() => {
            setShowDialog(false);
          }}
        />
      )}
    </>
  );
};

export default ActivityAttribution;
